export const FIELD_TOO_SHORT = (min: number) =>
    `The field must have at least ${min} characters`
export const FIELD_TOO_LONG = (max: number) =>
    `The maximum length is ${max} characters`
export const FIELD_REQUIRED = 'The field is required'
export const FIELD_INVALID_EMAIL_TOO_LONG =
    'The maximum length is 75 characters'
export const FIELD_INVALID_EMAIL = 'The email is invalid'
export const FIELD_INVALID_PHONE = 'The phone number is invalid'
export const FIELD_NEGATIVE_NUMBER = 'The field must contain positive numbers'
export const FIELD_GREATER_THAN_ZERO = 'The field must be greater than zero'
export const FIELD_MAX_NUMBER_OF_ENGINES = (max: number) =>
    `The maximum number of engines is ${max}`
export const FIELD_MAX_NUMBER_OF_OPE_UNITS = (max: number) =>
    `The maximum number of equipment units is ${max}`
export const FIELD_MIN_NUMBER_OF_ENGINES = (min: number) =>
    `At least ${min} engine is required on repower applications`
export const FIELD_UNSUPPORTED_COLLATERAL_ON_REPOWER = (
    collateralType: string,
) =>
    `This collateral type (${collateralType}) is not supported on repower applications`
export const FIELD_INVALID_SSN = 'The SSN number is invalid'
export const FIELD_INVALID_STATE =
    'Roadrunner does not finance applicants in the selected state'
export const FIELD_VALUE_MONTHS = 'Please enter a value between 0 and 11'

export const FIELD_PO_BOX_NOT_ALLOWED =
    'Please input a residential address, PO Boxes are not allowed'

export const FIELD_INVALID_CHARACTERS =
    'Only the following special characters are allowed: - . ( ) / & , \' " * + ! : #'
export const VIN_LENGTH = 'VIN must be 17 characters'
